import { render, staticRenderFns } from "./code-editor.vue?vue&type=template&id=65081539"
import script from "./code-editor.vue?vue&type=script&lang=js"
export * from "./code-editor.vue?vue&type=script&lang=js"
import style0 from "./code-editor.vue?vue&type=style&index=0&id=65081539&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports